import isObject from 'lodash/isObject';
import React from 'react';

import { sanitizeHTML } from '../../utilities';

export default function renderTitle(title, Component) {
  if (isObject(title) && title.content && title.color) {
    return (
      <Component className="react-rnd-draggable-cancel" textColor={title.color}>
        {title.content}
      </Component>
    );
  }

  if (typeof title === 'string') {
    return (
      <Component
        className="react-rnd-draggable-cancel"
        dangerouslySetInnerHTML={{
          __html: sanitizeHTML(title)
        }}
      />
    );
  }

  return null;
}
